// extracted by mini-css-extract-plugin
export default {"root":"root__kjUCr","rootFadeAnimation__":"rootFadeAnimation____Q3b4N","anchor":"anchor__3FZu1","textBlock":"textBlock__WBk-9"};